module.exports = __webpack_public_path__ + "static/media/share.2648782c.svg";